import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { TableCellProps } from 'react-virtualized';
import { RelativeTime } from 'src/components/BasicComponents';
import {
  type ManagedTracker,
  TrackerColumnKeys,
} from '../../../../store/trackers/trackers_reducers';
import { Columns } from '../../../DataTable';

interface CellProps extends TableCellProps {
  rowData: ManagedTracker;
}

export const LastMessageColumn = () => {
  const cellRenderer = ({ rowData }: CellProps) => {
    const lastMessage = rowData.messages.at(-1);
    if (lastMessage) {
      return (
        <Timestamp>
          <RelativeTime time={lastMessage.createdAt} size="short" />
        </Timestamp>
      );
    }
  };

  return Columns.sortingColumn({
    dataKey: TrackerColumnKeys.LAST_MESSAGE,
    label: 'Last Message',
    hint: 'Elapsed time since RACEMAP sent or tried to send the last message to the device.',
    cellRenderer,
    minWidth: 145,
    columnData: { hiddenOnDefault: true },
    sortingMethod: (_cA, _cB, rowDataA: ManagedTracker, rowDataB: ManagedTracker) => {
      const timeA = rowDataA?.messages?.at(-1)?.createdAt.getTime() ?? -1;
      const timeB = rowDataB?.messages?.at(-1)?.createdAt.getTime() ?? -1;
      return timeB - timeA;
    },
  });
};

const Timestamp = styled.div`
  font-size: smaller;
  color: ${RacemapColors.DarkGray};
`;
